<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template>
  <div id="app" :class="`Page${$route.name}`" @mousemove="activateUser">
    <transition enterActiveClass="animated fadeIn" leaveActiveClass="animated fadeOut"
                mode="out-in">
      <div class="videoContainer" v-show="playerDisplay">
        <div class="playerWrapper" :style="page.playerStyle">
          <div class="controlsWrapper" :class="controlPanelClasses" @click.self="closeAll">
            <transition enterActiveClass="animated fadeInRight"
                        leaveActiveClass="animated fadeOutLeft">
              <keep-alive>
                <Highlights v-if="highlights_on"/>
              </keep-alive>
            </transition>
            <transition enterActiveClass="animated fadeInRight"
                        leaveActiveClass="animated fadeOutLeft">
              <PlayerHighlights v-if="playerHighlights_on"/>
            </transition>
            <transition enterActiveClass="animated fadeInRight"
                        leaveActiveClass="animated fadeOutLeft">
              <Plays v-if="plays_on"/>
            </transition>
            <transition enterActiveClass="animated fadeInRight"
                        leaveActiveClass="animated fadeOutLeft">
              <Players v-if="players_on"/>
            </transition>
            <transition enterActiveClass="animated fadeInDown"
                        leaveActiveClass="animated fadeOutUp">
              <PlayerMenu
                  v-if="player.video_type === 'smart-highlights' && (anyPanel || userActive)"/>
            </transition>
            <Close v-if="false" class="exitFullscreen"/>
            <Live v-if="player.live_badge_shown"></Live>
            <PlayPause
                v-if="player.video_type === 'live'"
                :player-state="playerState"
                :player-instance="playerInstance"
            />
          </div>
          <video-player
              class="video-player-box videoInstance"
              ref="videoPlayer"
              :options="playerOptions"
              @ready="playerReadied($event)"
              @play="onPlayerPlay($event)"
              @ended="onPlayerEnded($event)"
              @pause="onPlayerPause($event)"
              @timeupdate="onTimeUpdate($event)"
              @error="$log.error($event)"
          >
          </video-player>
        </div>
      </div>
    </transition>
    <transition :enterActiveClass="anim.in" :leaveActiveClass="anim.out" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>

// import FadeLoader from 'vue-spinner/src/FadeLoader.vue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import MobileDetect from 'mobile-detect';
import Close from './components/glyphs/Close.vue';
import Live from './components/glyphs/Live.vue';
import PlayPause from './components/glyphs/PlayPause.vue';
import PlayerMenu from './components/PlayerMenu.vue';
import Plays from './components/Plays.vue';
import Players from './components/Players.vue';
import Highlights from './components/Highlights.vue';
import PlayerHighlights from './components/PlayerHighlights.vue';

require('./assets/css/custom-theme.css');

export default {
  name: 'app',
  data() {
    return {
      PI360: false,
      ta: false,
      hls: null,
    };
  },
  metaInfo() {
    return {
      title: "Highlights",
      meta: [
        { name: 'description', content:  'A-LIVE'},
        { property: 'og:title', content: "A-LIVE"},
        { property: 'og:description', content: "A-LIVE"},
        { property: 'og:site_name', content: 'A-LIVE'},
        {property: 'og:type', content: 'website'},
      ]
    }
  },
  components: {
    // FadeLoader,
    Close,
    Live,
    PlayPause,
    PlayerMenu,
    Highlights,
    PlayerHighlights,
    Players,
    Plays,
  },
  beforeMount() {
    const md = new MobileDetect(window.navigator.userAgent);
    this.setMd(md);
  },
  mounted() {
    this.loadTheHighlight();
  },
  methods: {
    ...mapActions(['loadTheHighlight']),
    ...mapMutations([
      'setVideo360',
      'setMd',
      'refreshPageSizeInfo',
      'playerReadied',
      'onPlayerPlay',
      'onPlayerEnded',
      'onPlayerPause',
      'playerStateChanged',
      'exitVideo',
      'setLoginInfo',
      'onTimeUpdate',
      'redirectToIP',
      'initModal',
      'toggleMute',
      'setShowPopover',
      'setUa',
    ]),
    set360Player(player) {
      this.PI360 = player;
    },
    activateUser() {
      this.setUa(true);
    },
    isConcert(name) {
      return this.$store.state.singleV === this.$store.state.concertMap[name];
    },
    closeModal() {
      this.initModal({ display: false });
    },
  },
  computed: {
    ...mapGetters(['getPI']),
    ...mapState([
      'me',
      'namespace',
      'page',
      'loading',
      'player',
      'playerOptions',
      'playerDisplay',
      'playerState',
      'playerInstance',
      'highlights_on',
      'playerHighlights_on',
      'plays_on',
      'players_on',
      'related_on',
      'loginInfo',
      'displayMe',
      'colors',
      'modal',
      'anim',
    ]),
    controlPanelClasses() {
      const classes = [];
      classes.push(this.$store.state.player.video_type);
      if (this.anyPanel) {
        classes.push('active');
      }
      return classes.join(' ');
    },
    anyPanel() {
      return this.plays_on || this.players_on || this.highlights_on || this.playerHighlights_on;
    },
    userActive() {
      if (this.playerInstance) {
        return this.playerInstance.userActive();
      }
      return false;
    },
  },
};
</script>
<style lang="scss">
body {
  margin: 0;
}

* {
  box-sizing: border-box;
}

@import url('https://fonts.googleapis.com/css?family=Roboto:400,500,800');
$bw: 100px;
$bos: $bw / 2;
.Landing__body__video {
  .video-js .vjs-big-play-button {
    display: unset;
    background-color: rgba(249, 142, 0, 0);
    border: 2px solid rgba(249, 142, 0, 1);
    cursor: pointer;
    height: $bw;
    width: $bw;
    line-height: $bw;
    top: calc(50% - #{$bos});
    left: calc(50% - #{$bos});
    border-radius: $bw;
    font-size: 30px;
  }
  .vjs-controls-disabled .vjs-big-play-button, .vjs-has-started .vjs-big-play-button, .vjs-using-native-controls .vjs-big-play-button, .vjs-error .vjs-big-play-button {
    display: none;
  }
 .vjs-big-play-button .vjs-icon-placeholder:before{
    font-size: 56px;
  }
}

.VueCarousel-dot-button:focus {
  outline: none !important;
}

.debug {
  padding: 20px;
  background-color: #fff;
  color: red;
  z-index: 2000;
}

.tlWm {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 15%;
  max-width: 220px;
}

.trWm {
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;

  img {
    height: 16px;
  }
}
.fixed {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}
</style>
